import React from "react";
import {
  IonBackdrop,
  IonContent,
  IonIcon,
  IonPage,
  IonText,
} from "@ionic/react";
import { alertCircleOutline, logOut } from "ionicons/icons";
import LogoutButton from "../../../components/helpers/LogoutButton";

type NoCMEDAccessErrorBackdrop = {
  errorMessage: string;
};
const NoCMEDAccessErrorBackdrop: React.FC<NoCMEDAccessErrorBackdrop> = ({errorMessage}) => {
  return (
    <>
    <IonPage>
      <IonContent>
        <IonBackdrop visible={true} style={{ opacity: 0.25 }}></IonBackdrop>
        <div id="box">
          <IonIcon icon={alertCircleOutline} color="danger" size="large" />
          <IonText style={{textAlign: "center"}} color="danger">
            {errorMessage}
          </IonText>
          <IonText></IonText>
          <IonText color="danger">
            Phone:
          </IonText>
          <IonText color="danger">
            United States +1 312 456 1560
          </IonText>
          <IonText color="danger">
            Europe +44 20 3379 3802
          </IonText>
          <IonText color="danger">
            or Asia +65 6593 5536
          </IonText>
          <IonText color="danger">
            Email: <a href="mailto:EASE.AtYourService@cmegroup.com">EASE.AtYourService@cmegroup.com</a>
          </IonText>
          <LogoutButton />
        </div>
      </IonContent>
    </IonPage>
    </>
  );
};

export default NoCMEDAccessErrorBackdrop;
